import { Flex, Result } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { RefusalReason, SigningRefusal } from "../types/signing.types"

interface Props {
  refusal: SigningRefusal | null
}

/**
 * Why the link did not open.
 *
 * Each reason gets its own wording. "Please contact the contractor" is true of
 * all of them and useful for none: somebody whose link expired needs a new one,
 * somebody whose project closed needs to know it closed, and somebody who has
 * just withdrawn their agreement needs to know that is what they did.
 */
const RefusedCard: React.FC<Props> = ({ refusal }) => {
  const { t } = useTranslation()
  const reason: RefusalReason = refusal?.reason ?? "unknown"

  const isCalm =
    reason === "consent_withdrawn" || reason === "envelope_not_live"

  return (
    <Flex vertical align="center" style={{ padding: "16px 0" }}>
      <Result
        status={isCalm ? "info" : "warning"}
        title={t(`signing.refused.${reason}.title`, {
          defaultValue: t("signing.refused.unknown.title")
        })}
        subTitle={t(`signing.refused.${reason}.detail`, {
          defaultValue: t("signing.refused.unknown.detail")
        })}
      />
    </Flex>
  )
}

export default RefusedCard
